export default {
  code: {
    title: 'Demande le code famille à tes parents et indique le ci-dessous ?',
    description:
      "Il peut s'agir d'un code partagé par tes parents ou ton école",
    submit: 'Vérifier',
    success: 'Tu as rejoint la famille avec succès !',
    invalid: 'Le code famille est invalide',
    incomplete: 'Le code doit contenir 6 caractères',
    valid: 'Code famille valide',
    helpButton: 'Comment trouver le code ?',
    helpTitle: 'Trouver le code famille',
    helpDescription:
      "Vous pouvez retrouver le code famille sur le profil de votre enfant. Il est affiché sur l'Accueil et également dans les Paramètres, en cliquant sur Voir le code famille.",
    congrats: {
      title: 'Bien joué !',
      description: 'Vous venez de rejoindre le compte famille.',
    },
    error: {
      fetchUsers: 'Impossible de récupérer les membres de la famille',
      join: 'Impossible de rejoindre la famille',
    },
    panel: {
      parent: {
        title: 'Est-ce que votre enfant possède déjà un compte Baobab ?',
      },
      child: {
        title: 'Est ce que ton parent possède déjà un compte Baobab ?',
      },
      yes: "Oui, j'ai un code",
      no: "Non, je n'ai pas de code",
    },
    selectUser: {
      parent: {
        title: 'Vous êtes?',
      },
      child: {
        title: 'Tu es?',
      },
      profileNotFound: {
        buttonText: 'Je ne trouve pas mon profil',
        title: 'Je ne trouve pas mon profil',
        description:
          "Demande à ton parent s'il a bien créé ton profil sur son espace Parents.",
        okButton: "J'ai compris",
      },
    },
    noChildren: 'Aucun profil enfant trouvé dans cette famille',
  },
};
